import React from "react";
import { Navigate } from "react-router-dom";

const LoginPvt = ({ Component }) => {
  const token = localStorage.getItem("token");
  return token ? <Navigate to="/dashboard" /> : <Component />;
};

export default LoginPvt;
